import axios from "axios";

export default axios.create({
  baseURL: process.env.REACT_APP_RECEIPT_URL,
  auth: {
    username: process.env.REACT_APP_RECEIPT_USERNAME,
    password: process.env.REACT_APP_RECEIPT_PASSWORD,
  },
  headers: {
    "Content-Type": "application/json"
  },
});
